<template>
  <div>
    <rest-form-item :label="$t('ChannelConfig_Mobivate_User')" prop="user">
      <el-input
        v-model="model.params.user"
        :placeholder="$t('ChannelConfig_Mobivate_User_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Mobivate_Password')"
      prop="password"
    >
      <el-input
        v-model="model.params.password"
        :placeholder="$t('ChannelConfig_Mobivate_Password_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Mobivate_Route')" prop="route">
      <el-input
        v-model="model.params.route"
        :placeholder="$t('ChannelConfig_Mobivate_Route_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Mobivate_PostbackAccount')"
      prop="account"
    >
      <el-input
        v-model="model.account"
        :placeholder="$t('ChannelConfig_Mobivate_PostbackAccount_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Mobivate_IgnorePermanentBounce')"
      prop="ignore_permanent_bounce"
    >
      <rest-form-select-boolean
        v-model="model.params.ignore_permanent_bounce"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import RestFormSelectBoolean from '@/common/components/rest/RestFormSelectBoolean'

export default {
  components: { RestFormItem, RestFormSelectBoolean },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'mobivate')
      this.$set(this.model, 'account', '')
      this.$set(this.model, 'params', { ignore_permanent_bounce: 0 })
    } else {
      const params = this.model.params || {}

      if (!Object.hasOwn(params, 'ignore_permanent_bounce')) {
        params['ignore_permanent_bounce'] = 0
        this.$set(this.model, 'params', params)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Mobivate.vue